import { TextField } from "@hid-galaxy-ui/galaxy-react";
import "./CustomTextField.scss";

interface CustomTextFieldProps {
  fieldKey: string;
  fieldLabel: string;
  fieldHelperText?: string;
  fieldValue: string;
  isRequired?: boolean;
  handleChange: (key: string, value: string) => void;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  fieldKey,
  fieldLabel,
  fieldHelperText = "",
  fieldValue,
  isRequired = false,
  handleChange,
}) => {
  return (
    <div className="custom-textfield-form-group">
      <TextField
        id={fieldKey}
        label={fieldLabel}
        name={fieldKey}
        helperText={fieldHelperText}
        value={fieldValue}
        isRequired={isRequired}
        theme="dark"
        onChange={(e) => handleChange(fieldKey, e.currentTarget.value)}
      />
    </div>
  );
};

export default CustomTextField;
